import { render, staticRenderFns } from "./companystatistics.vue?vue&type=template&id=4c614308&"
import script from "./companystatistics.vue?vue&type=script&lang=js&"
export * from "./companystatistics.vue?vue&type=script&lang=js&"
import style0 from "./companystatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports